import ChevronRightIcon from "../../img/icons/chevron-right.svg?react";
import Link from "../links/Link";
import {
  headingStyles,
  iconStyles,
  linkStyles,
} from "./headingInContainer.css";
import { HeadingInContainerProps } from "./types";

const HeadingInContainer = ({
  title,
  url,
  iconSize = 16,
  onClick,
}: HeadingInContainerProps) =>
  url ? (
    <Link to={url} className={linkStyles} onClick={onClick}>
      <div>
        <h2 className={headingStyles}>{title}</h2>
      </div>
      <div>
        <ChevronRightIcon
          width={iconSize}
          height={iconSize}
          className={iconStyles}
        />
      </div>
    </Link>
  ) : (
    <div>
      <h2 className={headingStyles}>{title}</h2>
    </div>
  );

export default HeadingInContainer;
